import instance from '../instance';
import getLiveElement from '../accessors/get-live-element';
import prepareSerializedStaticDocument from '../utils/helpers/prepare-serialized-static-document';

const shiftElement = (elementId, refElementId, position, updateStrategy) => {
  const element = getLiveElement(elementId);
  const refElement = getLiveElement(refElementId);
  instance.driver.shiftElement(element, refElement, position, updateStrategy);
  const clonedStaticDOM = instance.driver.getStaticDocument().cloneNode(true);

  return prepareSerializedStaticDocument(clonedStaticDOM);
};

export default shiftElement;
